import { render, staticRenderFns } from "./intelligentScreen.vue?vue&type=template&id=6028677e&scoped=true"
import script from "./intelligentScreen.vue?vue&type=script&lang=js"
export * from "./intelligentScreen.vue?vue&type=script&lang=js"
import style0 from "./intelligentScreen.vue?vue&type=style&index=0&id=6028677e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028677e",
  null
  
)

export default component.exports